import { MarketScoreMappedItemI } from "../../../domain";

const getStatusColor = (status: string, prefix?: string): string => {
  const colors: Record<string, string> = {
    approved: "#4CAF50",
    rejected: "#F44336",
    expired: "#F44336",
    counter: "#FFBD2E",
    "no cap": "#F44336",
  };

  if (prefix !== undefined) {
    return `${prefix}-[${colors[status] ?? "#9E9E9E"}]`;
  }

  return colors[status] ?? "#9E9E9E";
};

const marketScoresTextValues: Array<MarketScoreMappedItemI> = [
  { text: "- -", minValue: 0, maxValue: 0, color: "DOVE_GRAY" },
  {
    text: "Extremely Loose",
    minValue: 1,
    maxValue: 20,
    color: "GUARDSMAN_RED",
  },
  { text: "Loose", minValue: 21, maxValue: 40, color: "text-[#F48A2E]" },
  { text: "Moderate", minValue: 41, maxValue: 60, color: "text-[#BAA209]" },
  { text: "Tight", minValue: 61, maxValue: 80, color: "text-[#68C90E]" },
  {
    text: "Extremely Tight",
    minValue: 81,
    maxValue: 100,
    color: "text-[#009131]",
  },
];

const getTextFromMarketScore = (
  marketScoreValue: number
): MarketScoreMappedItemI => {
  const resultIndex = marketScoresTextValues.findIndex(
    (market) =>
      market.minValue <= marketScoreValue && market.maxValue >= marketScoreValue
  );

  return resultIndex !== -1
    ? marketScoresTextValues[resultIndex]
    : marketScoresTextValues[0];
};

const buildHighwayUrl = (highwayId?: string): string => {
  return `https://gohighway.com/broker/carriers/${highwayId || ""}`;
};

export { getStatusColor, getTextFromMarketScore, buildHighwayUrl };
